<template>
  <v-app id="item">
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-snackbar v-model="snackbar1" :timeout="10000" top color="red">
      <span>Incorrect Login Details</span> 
      <v-btn text color="white" @click="snackbar1 = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    
    <div class="mt-12">
        <v-footer class="mt-12 px-12 py-5" color="#333333" dark>
            <v-row align="center">
              <v-col cols="12" sm="6" md="3" :class="{ 'text-center': $vuetify.breakpoint.smAndDown}">
                <h2 class="pa-2">Features</h2>
                <ul class="pa-0">
                  <li><router-link to="/home" class="pa-2 white--text">Home</router-link></li>
                  <!-- <router-link to="/">Home</router-link>  -->
                  <li><router-link to="/importwishlist" class="pa-2 white--text">Import Wish List</router-link></li>
                  <li><router-link to="/earncrypto" class="pa-2 white--text">Earn Crypto</router-link></li>
                </ul>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="3" :class="{ 'text-center': $vuetify.breakpoint.smAndDown}">
                <h2 class="pa-2">Support</h2>
                <ul class="pa-0">
                  <li><a href="#" class="pa-2 white--text">Help Center</a></li>
                  <li><a href="#" class="pa-2 white--text">Contact Us</a></li>
                  <li><a href="#" class="pa-2 white--text">Save Big on Amazon</a></li>
                </ul>
              </v-col>
              <v-col cols="12" sm="6" md="3" :class="{ 'text-center': $vuetify.breakpoint.smAndDown}">
                <h2 class="pa-2 white--text">Company</h2>
                <ul class="pa-0">
                  <li><a href="#" class="pa-2 white--text">About</a></li>
                  <li><a href="#" class="pa-2 white--text">Team</a></li>
                  <li><a href="#" class="pa-2 white--text">Careers</a></li>
                </ul>
              </v-col> -->
              <v-col cols="12" sm="6" md="3" :class="{ 'text-center': $vuetify.breakpoint.smAndDown}">
                 <div class="mt-3">
                   <v-img src="/333.jpg" height="100px" contain>
                    </v-img>
                  </div>
               
              </v-col>
            </v-row>
            <v-card
            flat
            tile
            class="white--text text-center mx-auto"
            color="#333333"
          >
            <v-card-text>
              <v-btn
                v-for="icon in icons"
                :key="icon"
                class="mx-4 white--text"
                icon
              >
                <v-icon size="24px">{{ icon }}</v-icon>
              </v-btn>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-text class="white--text">
              {{ new Date().getFullYear() }} - Bitshopy
            </v-card-text>
          </v-card>
          
        </v-footer>
    </div>
    <!-- Unauthorised Dialog -->
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card class="pa-12 mx-auto" id="login" max-width="500" elevation="7">
        <v-system-bar light color="#ffffff" class="mt-n5">
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog=false">
                <v-icon color="red">mdi-close</v-icon>
            </v-btn>
        </v-system-bar>
        <div class="text-center mt-5 mb-4" style="color:#1a00d4">Session Expired! Re-Login</div>
        <v-card-text>
          <v-form>
            <v-text-field outlined dense label="Email"  prepend-inner-icon="mdi-account" name="username" v-model="this.$store.state.auth.logindetails.email" type="text" color="#1a00d4">

            </v-text-field>
            <v-text-field outlined dense class="mt-7" label="Password" name="password" v-model="password"
              :append-icon="show1 ? 'visibility' : 'visibility_off'" color="#1a00d4"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              prepend-inner-icon="mdi-lock"
              >
            </v-text-field>
            <v-card-text class="text-right">
              <v-btn text class="forgot mt-n9" to='/login' color="#1a00d4">Login Another Account?</v-btn>
            </v-card-text>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn large dark color="#1a00d4" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" v-on:click="login()">
                Login
            <v-icon right>mdi-login</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Server Error Catch -->
    <v-dialog v-model="dialogServer" overlay-color="black" width="700px" class="mt-12">
      <v-card width="685px" class=""> 
        <v-row style="background-color:white" >
          <v-col cols="12" sm="12" md="6">        
            <v-img src="/serverdown.png"></v-img>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="mx-auto">
            <v-container fluid class="fill-height">
              <v-row justify-center align="center" justify="center">
              <v-card-text class="font-weight-black">THE SERVER IS TEMPORARILY DOWN!!!<br>TRY AGAIN LATER</v-card-text>
            </v-row>
            
            </v-container>
          </v-col>
        </v-row>
        <v-card-text class="text-right">
        <v-btn dark color="rgba(98, 174, 50, 0.7)" @click="dialogServer=false">TRY AGAIN</v-btn>
      </v-card-text>
        
      </v-card>
      
    </v-dialog>
  </v-app>
</template>
<script>
import axios from 'axios'

export default {
  
    data () {
      return {
        snackbar: false,
        snackbar1: false,
        text: 'Your account has not been verified! Check your mail for verification link',
        vertical: true,
        icons: [
          'mdi-facebook',
          'mdi-twitter',
          'mdi-linkedin',
          'mdi-instagram',
        ],
        dialog:false,
        dialogServer:false,
        password:'',
        show1:false,
        loading:false
      }
    },
    computed(){
     
            
    },
    created: function () {
      this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)

      axios.interceptors.response.use(null, error => {
        if (error.response.status === 401) {
          this.dialog=true
        }else if(error.response.status === 500){
          this.dialogServer=true
        }

        return Promise.reject(error);
      });
    },
    mounted(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
          this.snackbar=true
        }
    
    },
    methods:{
      login(){
        this.loading = true
        this.$store.dispatch("Login", {
        "email": this.$store.state.auth.logindetails.email,
        "password": this.password
        })
        .then((success)=>{
          console.log(success);
          this.loading = false
          this.dialog = false
          this.$forceUpdate()
          this.$router.go(0);
        })
        .catch((error)=>{
          console.log(error);
          if(error.response.status===400){
            this.loading = false;
            this.snackbar1 = true;
          }else{
            this.loading = false
            this.snackbar1 = true
          }
        
        });
      },
    }
}
</script>
<style>
  #item{
    font-family: 'Roboto' 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  ul {list-style: none; margin: 0; padding:0}
   a:link, a:visited {
  text-decoration: none;
}
a:hover, a:active {
  background-color: grey;
  color: #fff;
  text-decoration: none;
  /* text-shadow: 1px 1px 1px #333; */
}
THEAD{
  background-color: #E0E0E0;
}
</style>

